export default "https://cdn-static.gokick.com/assets/0488227f5b7e53bbf90738be35137ce008cd4a94/images/Sleep_Web_Bottle.d29a408775b1bc1a14ec87c9335374d5.png";